import { Patch } from "..";

export default [
    {
        name: "菜单倒计时冻结",
        patches: [{ offset: 0x89F567, off: [0x0F, 0x84], on: [0x90, 0xE9] }],
    },
    {
        name: "PF 倒计时冻结",
        patches: [{ offset: 0x7E121D, off: [0x7E], on: [0xEB] }],
    },
    {
        name: "选曲游标锁定",
        patches: [{ offset: 0x82B02C, off: [0x74, 0x21], on: [0x90, 0x90] }],
    },
    {
        name: "开始时按住 START 一直暂停歌曲",
        patches: [{ offset: 0x84BBF7, off: [0x7D, 0x36], on: [0x90, 0x90] }],
    },
    {
        name: "启用 1P PF",
        patches: [{ offset: 0x8259A9, off: [0x75], on: [0xEB] }],
    },
    {
        name: "启用 2P PF",
        patches: [
            { offset: 0x825B8A, off: [0x74, 0x1B], on: [0x90, 0x90] },
            { offset: 0x825BA0, off: [0x74, 0x05], on: [0x90, 0x90] },
        ]
    },
    {
        name: "Force Custom Timing and Adapter Mode in LDJ (Experimental)",
        patches: [
            { offset: 0x75F763, off: [0x75], on: [0xEB] },
            { offset: 0x96CD77, off: [0x74, 0x03], on: [0x90, 0x90] },
        ]
    },
    {
        type: "union",
        name: "Choose Custom LDJ Timing/Adapter FPS",
        offset: 0x96CB71,
        patches: [
            {
                name: "60 FPS",
                patch: [0xC7, 0x45, 0xDB, 0x3C, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0x3C, 0x00, 0x00, 0x00],
            },
            {
                name: "120 FPS",
                patch: [0xC7, 0x45, 0xDB, 0x78, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0x78, 0x00, 0x00, 0x00],
            },
            {
                name: "144 FPS",
                patch: [0xC7, 0x45, 0xDB, 0x90, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0x90, 0x00, 0x00, 0x00],
            },
            {
                name: "165 FPS",
                patch: [0xC7, 0x45, 0xDB, 0xA5, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0xA5, 0x00, 0x00, 0x00],
            },
            {
                name: "240 FPS",
                patch: [0xC7, 0x45, 0xDB, 0xF0, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0xF0, 0x00, 0x00, 0x00],
            },
            {
                name: "360 FPS",
                patch: [0xC7, 0x45, 0xDB, 0x68, 0x01, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0x68, 0x01, 0x00, 0x00],
            },
        ]
    },
    {
        name: "跳过显示器检测",
        patches: [
            { offset: 0x868F6A, off: [0x8C], on: [0x8D] },
            { offset: 0x868FCA, off: [0x77, 0x0E], on: [0x90, 0x90] },
            { offset: 0x868FD4, off: [0x0F, 0x86, 0x8B, 0x00, 0x00, 0x00], on: [0xE9, 0x8C, 0x00, 0x00, 0x00, 0x90] },
        ],
    },
    {
        type: "union",
        name: "跳过显示器检测 FPS",
        offset: 0x87D7E0,
        patches: [
            {
                name: "默认",
                patch: [0x44, 0x8B, 0x91, 0x70, 0x0B, 0x00, 0x00, 0x44, 0x8B, 0xCA, 0x4C, 0x8B, 0xD9, 0x41, 0x81, 0xC2, 0x67, 0x01, 0x00, 0x00],
            },
            {
                name: "60.0000 FPS",
                patch: [0x48, 0xB8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x4E, 0x40, 0x66, 0x48, 0x0F, 0x6E, 0xC0, 0xF2, 0x0F, 0x58, 0xC8, 0xC3],
            },
            {
                name: "120.0000 FPS",
                patch: [0x48, 0xB8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x5E, 0x40, 0x66, 0x48, 0x0F, 0x6E, 0xC0, 0xF2, 0x0F, 0x58, 0xC8, 0xC3],
            },
            {
                name: "144.0000 FPS",
                patch: [0x48, 0xB8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x62, 0x40, 0x66, 0x48, 0x0F, 0x6E, 0xC0, 0xF2, 0x0F, 0x58, 0xC8, 0xC3],
            },
            {
                name: "165.0000 FPS",
                patch: [0x48, 0xB8, 0x00, 0x00, 0x00, 0x00, 0x00, 0xA0, 0x64, 0x40, 0x66, 0x48, 0x0F, 0x6E, 0xC0, 0xF2, 0x0F, 0x58, 0xC8, 0xC3],
            },
            {
                name: "240.0000 FPS",
                patch: [0x48, 0xB8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x6E, 0x40, 0x66, 0x48, 0x0F, 0x6E, 0xC0, 0xF2, 0x0F, 0x58, 0xC8, 0xC3],
            },
            {
                name: "360.0000 FPS",
                patch: [0x48, 0xB8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x80, 0x76, 0x40, 0x66, 0x48, 0x0F, 0x6E, 0xC0, 0xF2, 0x0F, 0x58, 0xC8, 0xC3],
            },
        ]
    },
    {
        type: "union",
        name: "选择 FPS 检测目标",
        offset: 0x870936,
        patches: [
            {
                name: "60 FPS",
                patch: [0x3C, 0x00],
            },
            {
                name: "120 FPS",
                patch: [0x78, 0x00],
            },
            {
                name: "144 FPS",
                patch: [0x90, 0x00],
            },
            {
                name: "165 FPS",
                patch: [0xA5, 0x00],
            },
            {
                name: "240 FPS",
                patch: [0xF0, 0x00],
            },
            {
                name: "360 FPS",
                patch: [0x68, 0x01],
            },
        ]
    },
    {
        name: "WASAPI 共享模式 (增加延迟)",
        patches: [{ offset: 0x4718BB, off: [0x44, 0x8B, 0xF2], on: [0x4D, 0x31, 0xF6] }],
    },
    {
        name: "快速重试",
        patches: [{ offset: 0x7AE270, off: [0x40, 0x53, 0x48, 0x83, 0xEC, 0x20], on: [0xB0, 0x01, 0xC3, 0x90, 0x90, 0x90] }],
    },
    {
        name: "阻止调整系统音量",
        patches: [{ offset: 0x56D781, off: [0xFF, 0x50, 0x38], on: [0x90, 0x90, 0x90] }],
    },
    {
        name: "强制 TDJ 模式",
        patches: [{ offset: 0x96CE27, off: [0x02], on: [0x03] }],
    },
    {
        name: "最大游戏音量",
        tooltip: "Ignore the in-game volume settings and use the maximum possible volume level. Especially helpful for TDJ which tends to be very quiet.",
        patches: [{ offset: 0x98E8F5, off: [0xFF, 0x90, 0x98, 0x00, 0x00, 0x00, 0x90], on: [0x90, 0x90, 0x90, 0x90, 0x90, 0x90, 0x90] }],
    },
    {
        name: "歌曲全解",
        patches: [{ offset: 0x7DB10A, off: [0x32, 0xC0], on: [0xB0, 0x01] }],
    },
    {
        name: "修复非 XONAR 声卡 ASIO 崩溃",
        patches: [{ offset: 0x99F41C, off: [0x00], on: [0x01] }],
    },
    {
        name: "启用 BPL BATTLE",
        patches: [{ offset: 0x825BF4, off: [0x74, 0x1C], on: [0x90, 0x90] }],
    },
    {
        name: "去除歌曲数量限制",
        patches: [{
            offset: 0x88A766, off: [0x7F, 0x19], on: [0x90, 0x90],
        }],
    },
    {
        name: "启用赤段",
        patches: [{
            offset: 0x9D8A2B,
            off: [
                0x4C, 0x8D, 0x05, 0xA6, 0x64, 0x2F, 0x00, 0x48, 0x8B, 0x94, 0x24, 0xE8, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x4C, 0x24, 0x48, 0xFF, 0x15, 0xC3, 0x58, 0x18, 0x00, 0x48, 0x89, 0x44, 0x24, 0x38, 0x48, 0x83, 0x7C, 0x24, 0x38, 0x00, 0x0F, 0x84, 0xAE, 0x00, 0x00, 0x00, 0x4C, 0x8D, 0x0D, 0x33, 0xBB, 0x51, 0x00, 0x4C, 0x8D, 0x84, 0x24, 0x88
            ],
            on: [
                0x48, 0x8B, 0x4C, 0x24, 0x58, 0x48, 0x81, 0xC1, 0xB8, 0x05, 0x00, 0x00, 0x48, 0xBA, 0xB0, 0x38, 0xB7, 0x80, 0x01, 0x00, 0x00, 0x00, 0x49, 0xC7, 0xC0, 0x2C, 0x00, 0x00, 0x00, 0xE8, 0xE3, 0xA6, 0x07, 0x00, 0x48, 0x8B, 0x4C, 0x24, 0x58, 0x48, 0x81, 0xC1, 0xE4, 0x05, 0x00, 0x00, 0x48, 0xBA, 0xDC, 0x38, 0xB7, 0x80, 0x01, 0x00, 0x00, 0x00, 0x49, 0xC7, 0xC0, 0x2C, 0x00, 0x00, 0x00, 0xE8, 0xC1, 0xA6, 0x07, 0x00, 0x48, 0x8B, 0x4C, 0x24, 0x58, 0x48, 0x81, 0xC1, 0xFC, 0x08, 0x00, 0x00, 0x48, 0xBA, 0x08, 0x39, 0xB7, 0x80, 0x01, 0x00, 0x00, 0x00, 0x49, 0xC7, 0xC0, 0x2C, 0x00, 0x00, 0x00, 0xE8, 0x9F, 0xA6, 0x07, 0x00, 0x48, 0x8B, 0x4C, 0x24, 0x58, 0x48, 0x81, 0xC1, 0x28, 0x09, 0x00, 0x00, 0x48, 0xBA, 0x34, 0x39, 0xB7, 0x80, 0x01, 0x00, 0x00, 0x00, 0x49, 0xC7, 0xC0, 0x2C, 0x00, 0x00, 0x00, 0xE8, 0x7D, 0xA6, 0x07, 0x00, 0xEB, 0x4F, 0x90, 0x90, 0x90
            ]
        },
        {
            offset: 0xB71EB0,
            off: [
                0x47, 0x64, 0x69, 0x70, 0x6C, 0x75, 0x73, 0x55, 0x74, 0x69, 0x6C, 0x3A, 0x3A, 0x43, 0x4A, 0x70, 0x65, 0x67, 0x45, 0x6E, 0x63, 0x6F, 0x64, 0x65, 0x72, 0x3A, 0x3A, 0x4C, 0x6F, 0x61, 0x64, 0x46, 0x72, 0x6F, 0x6D, 0x58, 0x38, 0x52, 0x38, 0x47, 0x38, 0x42, 0x38, 0x49, 0x6D, 0x61, 0x67, 0x65, 0x3A, 0x20, 0x72, 0x65, 0x73, 0x75, 0x6C, 0x74, 0x20, 0x3D, 0x20, 0x43, 0x72, 0x65, 0x61, 0x74, 0x65, 0x42, 0x69, 0x74, 0x6D, 0x61, 0x70, 0x28, 0x70, 0x53, 0x72, 0x63, 0x49, 0x6D, 0x61, 0x67, 0x65, 0x2C, 0x20, 0x77, 0x68, 0x6F, 0x6C, 0x65, 0x57, 0x69, 0x64, 0x74, 0x68, 0x2C, 0x20, 0x77, 0x68, 0x6F, 0x6C, 0x65, 0x48, 0x65, 0x69, 0x67, 0x68, 0x74, 0x2C, 0x20, 0x70, 0x69, 0x74, 0x63, 0x68, 0x49, 0x6E, 0x42, 0x79, 0x74, 0x65, 0x73, 0x2C, 0x20, 0x73, 0x72, 0x63, 0x58, 0x2C, 0x20, 0x73, 0x72, 0x63, 0x59, 0x2C, 0x20, 0x73, 0x72, 0x63, 0x57, 0x2C, 0x20, 0x73, 0x72, 0x63, 0x48, 0x2C, 0x20, 0x64, 0x65, 0x73, 0x74, 0x57, 0x2C, 0x20, 0x64, 0x65, 0x73, 0x74, 0x48, 0x2C, 0x20, 0x26, 0x6D, 0x5F, 0x70, 0x44, 0x61, 0x74, 0x61, 0x2D, 0x3E, 0x70, 0x42, 0x6D, 0x70, 0x29, 0x20
            ],
            on: [
                0x00, 0x00, 0x00, 0x00, 0x0F, 0x00, 0x00, 0x00, 0x02, 0x62, 0x00, 0x00, 0x03, 0x00, 0x00, 0x00, 0x1C, 0x5A, 0x00, 0x00, 0x03, 0x00, 0x00, 0x00, 0x3C, 0x4A, 0x00, 0x00, 0x03, 0x00, 0x00, 0x00, 0x75, 0x71, 0x00, 0x00, 0x03, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x10, 0x00, 0x00, 0x00, 0xDD, 0x59, 0x00, 0x00, 0x03, 0x00, 0x00, 0x00, 0xC6, 0x69, 0x00, 0x00, 0x03, 0x00, 0x00, 0x00, 0x31, 0x56, 0x00, 0x00, 0x03, 0x00, 0x00, 0x00, 0xB4, 0x69, 0x00, 0x00, 0x03, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x0F, 0x00, 0x00, 0x00, 0xB8, 0x3A, 0x00, 0x00, 0x08, 0x00, 0x00, 0x00, 0x69, 0x71, 0x00, 0x00, 0x08, 0x00, 0x00, 0x00, 0xD4, 0x69, 0x00, 0x00, 0x08, 0x00, 0x00, 0x00, 0x44, 0x75, 0x00, 0x00, 0x08, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x10, 0x00, 0x00, 0x00, 0x2C, 0x27, 0x00, 0x00, 0x08, 0x00, 0x00, 0x00, 0xD6, 0x65, 0x00, 0x00, 0x08, 0x00, 0x00, 0x00, 0xBB, 0x6D, 0x00, 0x00, 0x08, 0x00, 0x00, 0x00, 0x23, 0x5A, 0x00, 0x00, 0x08, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00
            ]
        }]
    },
    {
        name: "解锁所有副屏自定义",
        patches: [{
            offset: 0x9C8638,
            on: [0xBB, 0x00, 0x00, 0x00, 0x00, 0x83, 0xFB, 0x0E, 0x0F, 0x8D, 0x6F, 0x03, 0x00, 0x00, 0x48, 0x8B, 0x44, 0x24, 0x40, 0x48, 0x8B, 0x80, 0xF8, 0x00, 0x00, 0x00, 0x48, 0x63, 0xD3, 0x48, 0xC1, 0xE2, 0x03, 0x48, 0x01, 0xD0, 0x48, 0xC7, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0x83, 0xC3, 0x01, 0xEB, 0xD5],
            off: [0x4C, 0x8D, 0x05, 0xC9, 0x48, 0x30, 0x00, 0x48, 0x8B, 0x94, 0x24, 0x88, 0x03, 0x00, 0x00, 0x48, 0x8B, 0x4C, 0x24, 0x38, 0xFF, 0x15, 0xB6, 0x5C, 0x19, 0x00, 0x48, 0x89, 0x44, 0x24, 0x48, 0x48, 0x83, 0x7C, 0x24, 0x48, 0x00, 0x0F, 0x84, 0x52, 0x03, 0x00, 0x00, 0x48, 0x8B, 0x44, 0x24, 0x40],
        }]
    },
] as Patch[];
